<div
  class="fade modal-lg modal"
  id="exerciseListModal"
  tabindex="-1"
  aria-labelledby="exerciseListModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header w-100 d-flex justify-content-between">
        <h1 class="modal-title fs-5">Listado de ejercicios</h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>

      <div class="modal-body" *ngIf="user">
        <button
          class="btn-custom col-5 mb-3"
          data-bs-toggle="modal"
          data-bs-target="#exerciseFormModal"
          data-bs-dismiss="modal"
          aria-label="Close"
          *ngIf="userIsAdmin"
        >
          Crear Ejercicio
        </button>
        <select
          class="form-select"
          aria-label="Small select example"
          (change)="onSelectMuscleGroup($event)"
        >
          <option [value]="null" selected>Selecciona grupo muscular</option>
          <option
            [value]="muscleGroup.id"
            *ngFor="let muscleGroup of muscleGroups"
          >
            {{ muscleGroup.name }}
          </option>
        </select>

        <table class="table table-hover" *ngIf="muscleGroups && isMobile">
          <thead>
            <tr>
              <th scope="col">Nombre</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let exercise of exercises">
              <td
                (click)="selectExercise(exercise)"
                data-bs-toggle="modal"
                data-bs-target="#exerciseFormModal"
              >
                {{ exercise.name }}
              </td>
            </tr>
          </tbody>
        </table>
        <table class="table table-hover" *ngIf="exercises && !isMobile && user">
          <thead>
            <tr>
              <th scope="col">Nombre</th>
              <th scope="col">Descripción</th>
              <th scope="col" *ngIf="userIsAdmin">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let exercise of exercises">
              <td>{{ exercise.name }}</td>
              <td>
                {{
                  exercise.description.length > 30
                    ? (exercise.description | slice : 0 : 30) + "..."
                    : exercise.description
                }}
              </td>
              <td>
                <div class="d-flex justify-content-arround align-items-center">
                  <button
                    class="btn-custom me-2"
                    (click)="selectExercise(exercise)"
                    data-bs-toggle="modal"
                    data-bs-target="#exerciseFormModal"
                    *ngIf="userIsAdmin"
                  >
                    Detalle/editar
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
